var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fragment",
    [
      _vm.fullPage && !_vm.testing
        ? _c("portal", { attrs: { to: "modal", order: _vm.portalOrder } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loadedFilters,
                    expression: "loadedFilters"
                  }
                ],
                class: ["overlay-backdrop", _vm.fullPage && "is-full-page"],
                style: { zIndex: _vm.zIndex },
                attrs: { id: "overlay-backdrop" },
                on: { click: _vm.onClick }
              },
              [_vm._t("default")],
              2
            )
          ])
        : _c(
            "div",
            {
              staticClass: "overlay-backdrop",
              style: { zIndex: _vm.zIndex },
              attrs: { id: "overlay-backdrop" },
              on: { click: _vm.onClick }
            },
            [_vm._t("default")],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }